<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">安卓屏管理</p>
      <p v-if="view=='add'" @click="cancelHandle">安卓屏管理</p>
      <p v-if="view=='add'">>新增</p>
    </div>
    <div class="main-body" v-if="view == 'list'">
      <div class="list">
        <span>设备编号：</span>
        <el-input class="list-input" size="mini" v-model="number" placeholder="请输入设备编号"></el-input>
        <span class="ml10">屏幕方向：</span>
        <el-select class="fixed-width-100" size="mini" v-model="direction">
          <el-option
            v-for="(item,key) in directionList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="ml10">屏幕尺寸：</span>
        <el-select class="fixed-width-100" size="mini" v-model="size">
          <el-option v-for="(item) in sizeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="blue-btn ml10" @click="view = 'add'">新增</div>
      </div>
      <div class="list">
        <div class="normal-btn fixed-width-100" @click="onEditMainPicture(100, 0)">默认图片（竖屏）</div>
        <div class="normal-btn ml10 fixed-width-100" @click="onEditMainPicture(101, 1)">默认图片（横屏）</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th width="90px">设备编号</th>
          <th width="70px">UUID</th>
          <th width="40px">屏幕<br/>方向</th>
          <th width="50px">屏幕<br/>尺寸</th>
          <th width="125px">换电柜绑定</th>
          <th width="125px">用户关联</th>
          <th width="90px">换电柜编号</th>
          <th width="100px">关联用户</th>
          <th>
            换电柜<br/>通讯板编号
          </th>
          <th>换电柜名称</th>
          <th>投放地址</th>
          <th width="80px">创建时间</th>
          <th width="100px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.displayScreenNo }}</td>
          <td>{{ item.screenUUID }}</td>
          <td>{{ item.direction }}</td>
          <td>{{ item.size }}</td>
          <td>
            <div class="flex-bt">
              <div>{{ item.physicalNo == '' ? '未绑定' : '已绑定' }}</div>
              <div class="goodflex-bt">
                <div class="text-btn fixed-width-75"
                     v-if="item.physicalNo==''"
                     @click="onBindBtnClick(item)"
                >绑定
                </div>
                <div class="text-btn fixed-width-75" style="width: 100%"
                     v-if="item.physicalNo!=''"
                     @click="onUnbindBtnClick(item)"
                >解绑
                </div>
                <div class="text-btn fixed-width-75 mt4" style="width: 100%"
                     v-if="item.physicalNo!=''"
                     @click="onBindBtnClick(item)"
                >重新绑定
                </div>
              </div>

            </div>
          </td>
          <td>
            <div class="flex-bt">
              <div>{{ item.relateUserAccount == '' ? '未绑定' : '已绑定' }}</div>
              <div class="goodflex-bt">
                <div
                  class="text-btn fixed-width-75"
                  v-if="item.relateUserAccount==''"
                  @click="onBindUserBtnClick(item)"
                >绑定
                </div>
                <div
                  class="text-btn fixed-width-75"
                  v-if="item.relateUserAccount!=''" style="width: 100%"
                  @click="onUnUserbindBtnClick(item)"
                >解绑
                </div>
                <div
                  class="text-btn fixed-width-75 mt4"
                  v-if="item.relateUserAccount!=''" style="width: 100%"
                  @click="onBindUserBtnClick(item)"
                >重新绑定
                </div>
              </div>
            </div>
          </td>
          <td>{{ item.primaryDeviceNo }}</td>
          <td>{{ item.relateUserAccount }}</td>
          <td>{{ item.physicalNo }}</td>
          <td>{{ item.deviceName }}</td>
          <td>{{ item.location }}</td>
          <td>{{ item.createTime }}</td>
          <td>
            <div class="text-btn fixed-width-75" @click="onEditPicture(item.displayScreenNo, item.direction)">编辑图片</div>
            <div class="text-btn fixed-width-75 mt4" @click="onEditSize(item.screenUUID)">编辑尺寸</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="12">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条</div>
        <div class="page-count">
          跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <div class="main-body" v-if="view == 'add'">
      <charge-cabinet-mgmt-add-view @addSuccess="addSuccessHandle" @cancel="cancelHandle"
                                    :deviceType="'displayScreen'"></charge-cabinet-mgmt-add-view>
    </div>
    <el-dialog title="绑定设备" :visible.sync="bindDialogVisible" width="30%">
      <div class="list">
        <span>设备编号：</span>
        <el-input
          class="list-input fixed-width-180"
          size="mini"
          v-model="bindNumber"
          placeholder="输入设备编号/二维码/通讯板编号"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onBindBtnCancel">取消</el-button>
        <el-button type="primary" @click="onBindBtnConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="关联用户" :visible.sync="bindUserDialogVisible" width="30%">
      <div class="list">
        <span>用户编号/手机号：</span>
        <el-input
          class="list-input fixed-width-180"
          size="mini"
          v-model="bindNumber"
          placeholder="输入用户编号/手机号"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onBindUserBtnCancel">取消</el-button>
        <el-button type="primary" @click="onBindUserBtnConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑图片" :visible.sync="mainDialogVisible" width="50%">
      <div class="img-box" v-loading="loading">
        <div class="el-icon-delete delete-btn" @click="deletePicture(1)"></div>
        <el-upload
          class="avatar-uploader"
          action
          :show-file-list="false"
          :auto-upload="false"
          accept="image/*"
          :on-change="(file, fileList)=>handleUpload(file, fileList, 1)"
        >
          <img v-if="picture1" :src="pictureSrc1" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span>{{ editDirection == '0' ? '第一张上传尺寸540*960' : '第一张上传尺寸960*540' }}</span>
      </div>
      <div class="img-box" v-loading="loading">
        <div class="el-icon-delete delete-btn" @click="deletePicture(2)"></div>
        <el-upload
          class="avatar-uploader"
          action
          :show-file-list="false"
          :auto-upload="false"
          accept="image/*"
          :on-change="(file, fileList)=>handleUpload(file, fileList, 2)"
        >
          <img v-if="picture2" :src="pictureSrc2" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span>{{ editDirection == '0' ? '第二张上传尺寸540*268' : '第二张上传尺寸960*256' }}</span>
      </div>
      <div class="img-box" v-loading="loading" v-if="isMain">
        <div class="el-icon-delete delete-btn" @click="deletePicture(0)"></div>
        <el-upload
          class="avatar-uploader"
          action
          :show-file-list="false"
          :auto-upload="false"
          accept="image/*"
          :on-change="(file, fileList)=>handleUpload(file, fileList, 0)"
        >
          <img v-if="picture0" :src="pictureSrc0" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span>logo上传尺寸56*56</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑安卓屏尺寸" :visible.sync="editScreenDialogVisible" width="30%">
      <el-form label-position="right" label-width="80px" :model="editScreenData">
        <el-form-item label="屏幕uuId">
          <el-input v-model="editScreenData.uuid" disabled></el-input>
        </el-form-item>
        <el-form-item label="尺寸方向">
          <el-select class="fixed-width-100" size="mini" v-model="editScreenData.specifications">
            <el-option
              v-for="(item,key) in specificationsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="editScreenDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onEditScreenConfirm">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import ChargeCabinetMgmtAddView from "./chargeCabinetMgmtAddView";

export default {
  name: "displayScreenMgmt",
  components: {ChargeCabinetMgmtAddView},
  data() {
    return {
      number: "",
      direction: "",
      directionList: [
        {
          name: "全部",
          id: ""
        },
        {
          name: "竖屏",
          id: 0
        },
        {
          name: "横屏",
          id: 1
        }
      ],
      size: "",
      sizeList: [
        {
          name: "全部",
          id: ""
        },
        {
          name: "16.5寸",
          id: 0
        },
        {
          name: "10.1寸",
          id: 1
        }
      ],
      specificationsList: [
        {
          id: "100",
          name: "竖屏 16.5寸"
        },
        {
          id: "101",
          name: "横屏 10.1寸"
        }
      ],
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: "",
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dataList: [],
      bindDialogVisible: false,
      bindUserDialogVisible: false,
      bindNumber: "",
      bindUUID: "",
      mainDialogVisible: false,
      loading: false,
      isMain: false,
      editDirection: "0",
      editPicture: "",
      editNumber: "",
      picture0: "",
      pictureSrc0: "",
      type0: "",
      picture1: "",
      pictureSrc1: "",
      type1: "",
      picture2: "",
      pictureSrc2: "",
      type2: "",
      view: "list",
      editScreenData: {
        uuid: "",
        specifications: ""
      },
      editScreenDialogVisible: false,
    };
  },
  mounted() {
    this.queryDeviceList();
  },
  methods: {
    queryDeviceList: function () {
      let self = this;
      let params = {
        paramNo: this.number,
        direction: this.direction,
        size: this.size,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryDisplayScreen",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          self.dataList = res.ldata;
          self.resetPreAndNextBtn(self.dataList.length);
          self.dataList.length > self.pageSize && self.dataList.pop();
          self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
          self.pageIndex = self.page;
          // self.total = res.mdata.total;
          // self.totalPage = Math.floor((parseInt(res.mdata.total)-1)/self.pageSize)+1;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryDeviceList();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryDeviceList();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryDeviceList();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.queryDeviceList();
    },
    onAddBtnClick() {
      this.view = "add";
    },
    cancelHandle() {
      this.view = "list";
      this.queryDeviceList();
    },
    addSuccessHandle() {
      this.view = "list";
      this.queryDeviceList();
    },
    onEditMainPicture(number, direction) {
      this.resetPicture();
      this.getPicture(number);
      this.isMain = true;
      this.editDirection = direction;
      this.mainDialogVisible = true;
      this.loading = true;
    },
    onEditPicture(number, direction) {
      this.resetPicture();
      this.getPicture(number);
      this.editDirection = direction == "竖屏" ? 0 : 1;
      this.editNumber = number;
      this.isMain = false;
      this.mainDialogVisible = true;
      this.loading = true;
    },
    onEditSize(uuid) {
      this.editScreenData.uuid = uuid;
      // this.editScreenData.specifications = null;
      this.editScreenDialogVisible = true;
    },
    onEditScreenConfirm() {
      let self = this;
      let params = {
        uuid: this.editScreenData.uuid,
        specifications: this.editScreenData.specifications
      };
      this.$http
        .post(
          "/managementPlatform/electricity/addAndEditDisplayScreen",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.editScreenDialogVisible = false;
          self.$message({
            type: "success",
            message: "编辑成功!",
            center: true
          });
          self.$emit("addSuccess");
        })
        .catch(function (response) {
          console.log(response);
        });
      this.queryDeviceList();
    },
    getPicture(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryDisplayScreenPicture",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          let pictures = res.mdata.picture;
          if (pictures.picture_1) {
            let type1 = pictures.picture_1.split("/")[1].split(";")[0];
            let picture1 = pictures.picture_1.substring(
              22,
              pictures.picture_1.length
            );
            self.pictureSrc1 = pictures.picture_1;
            self.picture1 = picture1;
            self.type1 = type1;
          }
          if (pictures.picture_2) {
            let type2 = pictures.picture_2.split("/")[1].split(";")[0];
            let picture2 = pictures.picture_2.substring(
              22,
              pictures.picture_2.length
            );
            self.pictureSrc2 = pictures.picture_2;
            self.picture2 = picture2;
            self.type2 = type2;
          }
          if (pictures.picture_0) {
            let type0 = pictures.picture_0.split("/")[1].split(";")[0];
            let picture0 = pictures.picture_0.substring(
              22,
              pictures.picture_0.length
            );
            self.pictureSrc0 = pictures.picture_0;
            self.picture0 = picture0;
            self.type0 = type0;
          }
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    resetPicture() {
      this.picture0 = "";
      this.pictureSrc0 = "";
      this.type0 = "";
      this.picture1 = "";
      this.pictureSrc1 = "";
      this.type1 = "";
      this.picture2 = "";
      this.pictureSrc2 = "";
      this.type2 = "";
      this.editNumber = "";
    },
    handleUpload(file, fileList, number) {
      let self = this;
      let fileReader = new FileReader();
      fileReader.onloadend = function (e) {
        let src = e.target.result;
        console.log(number);
        if (number == 0) {
          self.pictureSrc0 = src;
          let pictureList = src.split(",");
          self.picture0 = pictureList[1];
          self.type0 = pictureList[0].split(";")[0].split("/")[1];
        } else if (number == 1) {
          self.pictureSrc1 = src;
          let pictureList = src.split(",");
          self.picture1 = pictureList[1];
          self.type1 = pictureList[0].split(";")[0].split("/")[1];
        } else {
          self.pictureSrc2 = src;
          let pictureList = src.split(",");
          self.picture2 = pictureList[1];
          self.type2 = pictureList[0].split(";")[0].split("/")[1];
        }
      };
      fileReader.readAsDataURL(file.raw);
    },
    deletePicture(number) {
      if (number == 1) {
        this.picture1 = "";
        this.pictureSrc1 = "";
        this.type1 = "";
      } else if (number == 2) {
        this.picture2 = "";
        this.pictureSrc2 = "";
        this.type2 = "";
      } else {
        this.picture0 = "";
        this.pictureSrc0 = "";
        this.type0 = "";
      }
    },
    cancel() {
      this.resetPicture();
      this.mainDialogVisible = false;
    },
    confirm() {
      this.mainDialogVisible = false;
      if (this.isMain && this.editDirection == "0") {
        this.confirmEditPicture("100");
      } else if (this.isMain && this.editDirection == "1") {
        this.confirmEditPicture("101");
      } else {
        this.confirmEditPicture(this.editNumber);
      }
    },
    confirmEditPicture(number) {
      let self = this;
      let params = {
        number: number
      };
      if (this.picture0) {
        params.picture0 = this.picture0;
        params.type0 = this.type0;
      }
      if (this.picture1) {
        params.picture1 = this.picture1;
        params.type1 = this.type1;
      }
      if (this.picture2) {
        params.picture2 = this.picture2;
        params.type2 = this.type2;
      }
      this.$http
        .post(
          "/managementPlatform/electricity/editDisplayScreenPicture",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "编辑失败!",
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "编辑成功!",
            center: true
          });
          self.queryDeviceList();
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    onBindBtnClick(item) {
      this.bindDialogVisible = true;
      this.bindUUID = item.screenUUID;
    },
    onBindUserBtnClick(item) {
      this.bindUserDialogVisible = true;
      this.bindUUID = item.screenUUID;
    },
    onBindBtnCancel() {
      this.bindDialogVisible = false;
      this.bindUUID = "";
      this.bindNumber = "";
    },
    onBindUserBtnCancel() {
      this.bindUserDialogVisible = false;
      this.bindUUID = "";
      this.bindNumber = "";
    },
    onBindBtnConfirm() {
      let self = this;
      let params = {
        screenUUID: this.bindUUID,
        paramNo: this.bindNumber
      };
      this.$http
        .post(
          "/managementPlatform/electricity/bindPrimaryDevice",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "绑定失败!",
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "绑定成功!",
            center: true
          });
          self.queryDeviceList();
          self.bindDialogVisible = false;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    onBindUserBtnConfirm() {
      let self = this;
      let params = {
        screenUUID: this.bindUUID,
        paramNo: this.bindNumber
      };
      this.$http
        .post(
          "/managementPlatform/electricity/relatedUserAccountNo",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "绑定失败!",
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "绑定成功!",
            center: true
          });
          self.queryDeviceList();
          self.bindUserDialogVisible = false;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    onUnbindBtnClick(item) {
      let self = this;
      this.$confirm("确定要解绑吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          self.unbindDevice(item.displayScreenNo);
        })
        .catch(() => {
        });
    },
    onUnUserbindBtnClick(item) {
      let self = this;
      this.$confirm("确定要解绑吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          self.unbindUserDevice(item.displayScreenNo);
        })
        .catch(() => {
        });
    },
    unbindDevice(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http
        .post(
          "/managementPlatform/electricity/cancelBindDisplayScreen",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "解绑失败!",
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "解绑成功!",
            center: true
          });
          self.queryDeviceList();
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    unbindUserDevice(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http
        .post(
          "/managementPlatform/electricity/cancelRelateDisplayScreen",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "解绑失败!",
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "解绑成功!",
            center: true
          });
          self.queryDeviceList();
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.goodflex-bt {
  display: flex;
  flex-wrap: wrap;
  /*justify-content:start;*/
}

.main-body {
  .flex-bt {
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #bee6b3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}

.list-input {
  width: 180px !important;
}

.avatar-uploader {
}

.img-box {
  width: 33%;
  height: 170px;
  float: left;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.delete-btn {
  font-size: 18px;
  position: absolute;
  top: 0;
  right: 35px;
  cursor: pointer;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.avatar {
  width: 200px;
  height: 150px;
  display: block;
}

.mt4 {
  margin-top: 4px;
}
</style>
<style>
.el-dialog__body {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/displayScreenMgmt.vue